export const isLinux: boolean = /linux/i.test(navigator.userAgent);
